/* global Vue */

import Vue from 'vue';

Vue.component('contact-form', require('./contact-form.vue'));
Vue.component('land-to-sell-form', require('./land-to-sell-form.vue'));
Vue.component('sidebar-signup-form', require('./sidebar-signup-form.vue'));
Vue.component('schedule-tour-form', require('./schedule-tour-form.vue'));
Vue.component('community-contact-form', require('./community-contact-form.vue'));
Vue.component('submit-service-request', require('./submit-service-request.vue'));
Vue.component('my-favorites-login-form', require('./my-favorites-login-form.vue'));
Vue.component('my-favorites-forgot-password-form', require('./my-favorites-forgot-password-form.vue'));
Vue.component('my-favorites-reset-password-form', require('./my-favorites-reset-password-form.vue'));
Vue.component('my-favorites-profile-form', require('./my-favorites-profile-form.vue'));
Vue.component('my-favorites-prelogin-form', require('./my-favorites-prelogin-form.vue'));
Vue.component('my-favorites-modal', require('./my-favorites-modal.vue'));
Vue.component('my-favorites-register-form', require('./my-favorites-register-form.vue'));
Vue.component('edit-profile-form', require('./edit-profile-form.vue'));
Vue.component('add-client-form', require('./add-client-form.vue'));
Vue.component('promotion-form', require('./promotion-form.vue'));
Vue.component('mlp-form', require('./mlp-form.vue'));
Vue.component('realtor-form', require('./realtor-form.vue'));
Vue.component('trade-partners-form', require('./trade-partners-form.vue'));
Vue.component('interest-list-form', require('./interest-list-form.vue'));
Vue.component('full-interest-form', require('./full-interest-form.vue'));
Vue.component('buy-now-form', require('./buy-now-form.vue'));
Vue.component('digital-registration-form', require('./digital-registration-form.vue'));
// Vue.component('career-form', require('./career-form.vue'));



// WEBPACK FOOTER //
// ./resources/components/forms/index.js